import React, { useEffect } from 'react';
import './ImageLightbox.css';

/**
 * Full-screen lightbox overlay for viewing images with details.
 * @param {Object} props
 * @param {string} props.src - Image source URL.
 * @param {string} [props.title] - Title shown below the image.
 * @param {string} [props.subtitle] - Subtitle/description shown below the title.
 * @param {Function} props.onClose - Called when the lightbox should close.
 */
export default function ImageLightbox({ src, title, subtitle, onClose }) {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  if (!src) return null;

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>&times;</button>
        <img src={src} alt={title || ''} className="lightbox-img" />
        {(title || subtitle) && (
          <div className="lightbox-info">
            {title && <div className="lightbox-title">{title}</div>}
            {subtitle && <div className="lightbox-subtitle">{subtitle}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
